export default __webpack_public_path__ + "static/media/graph.65b5da33.webp";